import LaptopScreen from "../LaptopScreen/LaptopScreen";
import Macbook from "../Models/Macbook";
import Name from "../Name";
import PhoneScreen from "../PhoneScreen/PhoneScreen";
import StickyNotes from "../StickyNotes";
import { useContext } from "react";
import { FocusDeviceContext } from "../providers/FocusDeviceProvider";

const Interactables = () => {
  const { isMacbookOn, setIsMacbookOn } = useContext(FocusDeviceContext);

  return (
    <>
      <Macbook
        castShadow
        isInteractionEnabled={!isMacbookOn}
        position-y={-1.5}
      />
      <LaptopScreen
        isLaptopOn={isMacbookOn}
        setIsLaptopOn={(isLaptopOn) => {
          setIsMacbookOn(isLaptopOn);
        }}
      />

      <PhoneScreen />
      <StickyNotes />
      <Name />
    </>
  );
};

export default Interactables;
